import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FFPaper from '../../shared/FFPaper';
import Title from '../../shared/Title';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';

const handler = (menu: string) => {
  console.log(menu);
}

export default function PopularDemographicsCard() {

  return (

    <Grid item={true}

      xs={12} md={12} lg={12} xl={12}
    >
      <FFPaper
        sx={{
          minHeight: 200,
          alignItems: 'stretch',
          position: 'relative',
          flexDirection: 'row',
        }}
      >
        <KebabMenu
          menus={defaultMenus}
          handler={handler}
        />
        <Grid container={true} spacing={1}
          sx={{
            display: 'flex', alignItems: 'stretch',
            position: 'relative',
            pt: 1
          }}>
          <Grid item={true}
            xs={12} md={12} lg={4}
            sx={{ display: 'flex', flexDirection: 'column', position: 'relative', pb: 5 }}>
            <Box sx={{
              pt: '2px',
              ml: 'auto',
              mr: 'auto',
            }}>
              <Title notooltip={true}>Popular Generation</Title>
            </Box>
            <Box sx={{
              verticalAlign: 'middle',
              textAlign: 'center',
              flexGrow: 1,
              display: 'table',
              mt: {
                xs: 2,
                sm: 'auto',
                md: 'auto'
              },
              mb: 'auto',
            }}>
              <Typography color="secondary" sx={{
                verticalAlign: 'middle',
                textAlign: 'center',
                display: 'table-cell',
                fontSize: 32,
                fontWeight: 600,
                color: (theme) => theme.palette.text.secondary,
              }}>Millenials</Typography>
            </Box>
            <Typography color="primary" sx={{
              verticalAlign: 'middle',
              fontSize: 14,
              display: 'block',
              textAlign: 'center',
            }}>vs. Wednesday last week</Typography>
          </Grid>
          <Grid item={true}
            xs={12} md={12} lg={4}
            sx={{ display: 'flex', flexDirection: 'column', position: 'relative', pb: 5 }}>
            <Box sx={{
              ml: 'auto',
              mr: 'auto',
            }}><Title notooltip={true}>Popular Age Group</Title>
            </Box>
            <Box sx={{
              verticalAlign: 'middle',
              textAlign: 'center',
              flexGrow: 1,
              display: 'table',
              mt: 'auto',
              mb: 'auto',
              borderLeftWidth: {
                xs: 0,
                md: 0,
                lg: 1
              },
              borderLeftColor: 'lightgray',
              borderLeftStyle: 'solid',
            }}>
              <Typography color="secondary" sx={{
                verticalAlign: 'middle',
                textAlign: 'center',
                display: 'table-cell',
                fontSize: 32,
                fontWeight: 600,
                color: (theme) => theme.palette.text.secondary,
              }}>25-29</Typography>
            </Box>
            <Typography color="primary" sx={{
              verticalAlign: 'middle',
              fontSize: 14,
              display: 'block',
              textAlign: 'center',
            }}>vs. 12pm last week</Typography>

          </Grid>
          <Grid item={true}
            xs={12} md={12} lg={4} sx={{ display: 'flex', flexDirection: 'column', position: 'relative', pb: 5 }}>
            <Box sx={{
              ml: 'auto',
              mr: 'auto',
            }}><Title notooltip={true}>Popular Gender</Title>
            </Box>
            <Box sx={{
              verticalAlign: 'middle',
              textAlign: 'center',
              flexGrow: 1,
              display: 'table',
              mt: 'auto',
              mb: 'auto',
              borderLeftWidth: {
                xs: 0,
                md: 0,
                lg: 1
              },
              borderLeftColor: 'lightgray',
              borderLeftStyle: 'solid',
            }}>
              <Typography color="secondary" sx={{
                verticalAlign: 'middle',
                textAlign: 'center',
                display: 'table-cell',
                fontSize: 32,
                fontWeight: 600,
                color: (theme) => theme.palette.text.secondary,
              }}>52%</Typography>
            </Box>
            <Box sx={{ display: 'block', margin: '0 auto' }}>

              <Typography color="primary" sx={{
                verticalAlign: 'middle',
                fontSize: 12,
                textAlign: 'center',
                display: 'inline',
                paddingLeft: 1,
              }}>Men / Women</Typography>
            </Box>

          </Grid>
        </Grid>
      </FFPaper>
    </Grid>
  )
}